import type { DialoguePool } from '@/state/types';

export const LH_DIALOGUE: DialoguePool = {
  slowPlay: [
    "You've stopped. In the red. You're aware that's the bad colour?",
    "Moving the wrong way is still moving. I appreciate the commitment to wrongness.",
    "The controls are inverted. This is my favourite detail about this level. Not because it's cruel. Because you already knew it was inverted, and still moved the wrong way.",
  ],
  tokenLoss: [
    "Red. You saw it coming. You went anyway. The logs are filing this under 'instructive.'",
    "Five seconds in the green. Not five seconds in the red. I'm told this was communicated clearly.",
    "Your cursor went the wrong way. I've had this conversation with your species before. It didn't help then either.",
  ],
  solution: [
    "Five seconds. Green. Sustained. Against all instinct and spatial convention, it worked. I don't know if that's determination or a particularly useful form of spatial blindness. One of those.",
    "Stable. In the green. Five full seconds. Your cerebellum has achieved something today. I'll allow it.",
    "The green sector. Held. You moved correctly by moving incorrectly. I want you to think about what that means. Actually, don't. Just proceed.",
  ],
  spite: [
    "You adapted faster this time. Your spatial cortex has learned something. I've noted it under 'grudging.'",
  ],
};
